export const Paraphrasing = () => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons" clipPath="url(#clip0_3128_12717)">
      <g id="Group">
        <path
          id="Vector"
          d="M2.09134 5.94945C1.24016 5.94945 0.5 6.78783 0.5 7.75195V9.63827V26.6152V26.9086C0.5 28.3338 1.49921 29.5075 2.75748 29.5075H18.4488C18.8929 29.5075 19.3 29.0883 19.3 28.5434V24.0162V7.03933V6.87166C19.3 6.36864 18.9299 5.90753 18.4488 5.90753H2.09134V5.94945Z"
          fill="#018374"
        />
        <g id="Group 898">
          <path
            id="Vector_2"
            d="M22.9797 23.212C22.9797 24.0344 22.3599 24.6836 21.5749 24.6836H6.70013C5.29529 24.6836 4.17969 23.4717 4.17969 22.0001V4.16722C4.17969 2.69558 5.29529 1.48364 6.70013 1.48364H22.9797V23.212Z"
            fill="white"
            stroke="#018374"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="Vector_3">
            <path d="M8.51831 19.0135V27.8001L10.7908 25.9389L13.1047 27.8001V19.0135" fill="white" />
            <path
              d="M8.51831 19.0135V27.8001L10.7908 25.9389L13.1047 27.8001V19.0135"
              stroke="#018374"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_4"
            d="M4.17969 2.26277V21.7404C4.17969 20.2687 5.29529 19.0568 6.70013 19.0568H22.9797V0.40158H5.95639C5.00606 0.358297 4.17969 1.22396 4.17969 2.26277Z"
            fill="white"
            stroke="#018374"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3128_12717">
        <rect width="30" height="30" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
